import { MenuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';

export const menuTranslation: MenuTranslation = {
  analysisRemarks: 'Uwagi do analiz',
  experienceCompanies: 'Firmy doświadczenia',
  interviewSimulation: 'Symulacja rozmowy',
  meetings: 'Spotkania',
  processes: 'Procesy',
  processTemplates: 'Szablony procesów',
  statistics: 'Statystyki',
};
